<template>
  <div class="caption-builder">
    <div class="form-group">
      <label>
        {{ label }}
      </label>
      <input
        ref="captionInput"
        type="text"
        :name="name"
        :value="caption"
        class="form-control"
        @input="updateCaption"
      />
      <small class="form-text text-muted d-block mt-2">
        {{ help }}
      </small>
      <small class="form-text text-muted d-block">
        {{ tag }}
      </small>
    </div>

    <div class="available-tags mt-3">
      <span
        v-for="field in availableFields"
        :key="field"
        class="badge badge-light cursor-pointer me-2 mb-2"
        @click="insertTag(field)"
        title="Click to insert tag"
      >
        {{ formatTag(field) }}
      </span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CaptionBuilder',
  props: {
    name: {
      type: String,
      default: 'registrationCaption',
    },
    initialValue: {
      type: String,
      default: '',
    },
    fields: {
      type: Array,
      default: () => [],
    },
    label: {
      type: String,
      default: 'Registration Caption',
    },
    help: {
      type: String,
      default: 'Enter registration caption',
    },
    tag: {
      type: String,
      default: 'Available tags to insert',
    },
  },
  data() {
    return {
      caption: '',
    }
  },
  computed: {
    availableFields() {
      return this.fields
    },
  },
  methods: {
    updateCaption(event) {
      this.caption = event.target.value
    },
    formatTag(field) {
      return `{{registration.${field}}}`
    },
    insertTag(field) {
      const input = this.$refs.captionInput
      const tag = this.formatTag(field)
      const start = input.selectionStart
      const end = input.selectionEnd
      const before = this.caption.substring(0, start)
      const after = this.caption.substring(end)

      this.caption = before + tag + after

      // Update input value
      this.$nextTick(() => {
        input.value = this.caption
        // Position cursor after inserted tag
        const newPos = start + tag.length
        input.setSelectionRange(newPos, newPos)
        input.focus()
      })
    },
  },
  mounted() {
    this.caption = this.initialValue
  },
}
</script>

<style scoped>
.caption-builder {
  /* Component styles */
}

.available-tags {
  display: flex;
  flex-wrap: wrap;
}

.badge {
  cursor: pointer;
  user-select: none;
  transition: background-color 0.2s;
}

.badge:hover {
  background-color: #e9ecef !important;
}
</style>
